import { useMemo } from 'react'

import { useSession } from '@/shared/services/session/compat'

import { clientEnv } from '@/env.client'

import { isDebugPanelEligible } from './eligibility'

/**
 * Elegibilidade ao ferramental de staff, montada a partir da sessão corrente.
 *
 * A regra pura vive em `eligibility.ts` e é testada isoladamente; este hook só
 * junta as entradas. Existe porque a seção `/minha-conta/desenvolvimento`
 * precisa da mesma resposta em dois pontos — a guarda da rota e a entrada na
 * faixa de navegação — além do próprio painel.
 */
export function useDebugPanelEligible(): boolean {
  const { status, data: session } = useSession()

  return useMemo(
    () =>
      isDebugPanelEligible({
        dev: import.meta.env.DEV,
        vercelEnv: clientEnv.NEXT_PUBLIC_VERCEL_ENV,
        sessionStatus: status === 'loading' ? 'unauthenticated' : status,
        email: session?.user?.email
      }),
    [status, session?.user?.email]
  )
}
